"use strict";

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [0, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

require("./index.less");

var react_images_1 = require("react-images");

var lightboxStyle = {
  container: {
    background: 'rgba(255, 255, 255, 0.95)',
    gutter: {
      horizontal: 10,
      vertical: 10
    }
  },
  header: {
    height: '50px'
  },
  close: {
    ':hover': {
      opacity: 1
    },
    height: '50px',
    width: '50px',
    margin: 0,
    opacity: 0.8,
    transition: 'all 300ms'
  },
  arrow: {
    ':hover': {
      opacity: 1
    },
    width: '70px',
    opacity: 0.8,
    transition: 'all 300ms'
  },
  arrow__size__medium: {
    '@media (min-width: 768px)': {
      width: '70px !important'
    },
    width: '70px'
  }
};

var GridGallery = function (_super) {
  __extends(GridGallery, _super);

  function GridGallery(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      items: [],
      lightboxOpen: false,
      currentImage: 0
    };
    return _this;
  }

  GridGallery.prototype.componentDidMount = function () {
    var lightboxImages = this.props.lightboxImages;
    var nextState = [];
    lightboxImages.forEach(function (image) {
      nextState.push({
        src: image.url
      });
    });
    this.setState({
      items: nextState
    });
  };

  GridGallery.prototype.componentWillReceiveProps = function (nextProps) {
    var lightboxImages = nextProps.lightboxImages;
    var nextState = [];
    lightboxImages.forEach(function (image) {
      nextState.push({
        src: image.url
      });
    });
    this.setState({
      items: nextState
    });
  };

  GridGallery.prototype.onValue = function (field, value, isValid) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, items, lightboxOpen, currentImage, _b;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _a = this.state, items = _a.items, lightboxOpen = _a.lightboxOpen, currentImage = _a.currentImage;
            _b = field;

            switch (_b) {
              case "image":
                return [3
                /*break*/
                , 1];
            }

            return [3
            /*break*/
            , 3];

          case 1:
            return [4
            /*yield*/
            , this.setState({
              currentImage: value
            })];

          case 2:
            _c.sent();

            this.onAction("open");
            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  GridGallery.prototype.onAction = function (action) {
    var _a = this.state,
        items = _a.items,
        lightboxOpen = _a.lightboxOpen,
        currentImage = _a.currentImage;

    switch (action) {
      case "prevImage":
        this.setState({
          currentImage: currentImage - 1
        });
        break;

      case "nextImage":
        this.setState({
          currentImage: currentImage + 1
        });
        break;

      case "close":
        this.setState({
          lightboxOpen: false
        });
        break;

      case "open":
        this.setState({
          lightboxOpen: true
        });
        break;
    }
  };

  GridGallery.prototype.render = function () {
    var _this = this;

    var _a = this.state,
        items = _a.items,
        lightboxOpen = _a.lightboxOpen,
        currentImage = _a.currentImage;
    var _b = this.props,
        lightboxImages = _b.lightboxImages,
        download = _b.download;
    var padding = this.props.gutter / 2;
    var children = React.Children.map(this.props.children, function (child, index) {
      return React.cloneElement(child, {
        key: index,
        padding: padding,
        index: index,
        context: _this
      });
    });
    var downloadLink;

    if (download) {
      downloadLink = !!lightboxImages[currentImage] ? React.createElement("a", {
        key: 0,
        className: "h4 download-link",
        style: {
          padding: 10
        },
        href: lightboxImages[currentImage].url,
        download: lightboxImages[currentImage].name
      }, (lightboxImages[currentImage] ? lightboxImages[currentImage].name + ' -' : '') + "Download\xA0", React.createElement("i", {
        className: "icon icon--xs icon-Download type--bold"
      })) : React.createElement("a", {
        key: 0,
        className: "h4 download-link",
        style: {
          padding: 10
        },
        href: "",
        download: ""
      }, (lightboxImages[currentImage] ? lightboxImages[currentImage].name + ' -' : '') + "Download\xA0", React.createElement("i", {
        className: "icon icon--xs icon-Download type--bold"
      }));
    }

    var customControls = [downloadLink];
    return React.createElement("div", null, !!download ? lightboxOpen && React.createElement(react_images_1["default"], {
      images: items,
      isOpen: lightboxOpen,
      currentImage: currentImage,
      customControls: customControls,
      onClickPrev: function onClickPrev() {
        return _this.onAction("prevImage");
      },
      onClickNext: function onClickNext() {
        return _this.onAction("nextImage");
      },
      onClose: function onClose() {
        return _this.onAction("close");
      },
      theme: lightboxStyle
    }) : lightboxOpen && React.createElement(react_images_1["default"], {
      images: items,
      isOpen: lightboxOpen,
      currentImage: currentImage,
      onClickPrev: function onClickPrev() {
        return _this.onAction("prevImage");
      },
      onClickNext: function onClickNext() {
        return _this.onAction("nextImage");
      },
      onClose: function onClose() {
        return _this.onAction("close");
      },
      theme: lightboxStyle
    }), React.createElement("div", {
      style: {
        padding: padding
      }
    }, children));
  };

  return GridGallery;
}(React.Component);

exports["default"] = GridGallery;

var GridImage = function (_super) {
  __extends(GridImage, _super);

  function GridImage(props) {
    var _this = _super.call(this, props) || this;

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  Object.defineProperty(GridImage.prototype, "url", {
    get: function get() {
      return this.props.children;
    },
    enumerable: true,
    configurable: true
  });

  GridImage.prototype.onClick = function (value) {
    this.props.context.onValue("image", value, true);
  };

  GridImage.prototype.render = function () {
    var _this = this;

    var imageStyle = {
      position: "relative",
      width: "100%",
      paddingBottom: "100%",
      backgroundImage: "url(" + this.url + ")",
      backgroundSize: "cover",
      backgroundPosition: "center center",
      backgroundRepeat: 'no-repeat',
      borderRadius: 4
    };
    return React.createElement("div", {
      className: "image-wrapper fadein",
      style: {
        display: "block",
        padding: this.props.padding,
        "float": "left"
      }
    }, React.createElement("div", {
      onClick: function onClick() {
        return _this.onClick(_this.props.index);
      }
    }, React.createElement("div", {
      className: "grid-image",
      style: imageStyle
    })));
  };

  return GridImage;
}(React.Component);

exports.GridImage = GridImage;